import { PiFilesFill } from "react-icons/pi";
import React from "react";
import { FaPlus } from "react-icons/fa";
import PrimaryBtn from "../../../utils/PrimaryBtn/PrimaryBtn";

const Card = ({
  number_of_courses,
  combo,
  coursePrice1,
  coursePrice2,
  razorLink,
  discountPrice,
  courseName1,
  courseName2,
  courseImage1,
  courseImage2,
}) => {
  let list = [
    {
      course_name: courseName1,
      img: courseImage1,
      coursePrice: coursePrice1,
    },
    {
      course_name: courseName2,
      img: courseImage2,
      coursePrice: coursePrice2,
    },
  ];

  return (
    <div className="border-2 py-10 px-5 rounded-md max-sm:py-6 max-sm:px-3">
      <div className="flex items-center gap-2">
        {" "}
        {list.map((val, index, array) => (
          <>
            <div
              key={index}
              className="rounded-md overflow-hidden w-full shadow-lg">
              <img src={val.img} className=" w-full" alt="img" />
              <div className="text-primary flex justify-between bg-[#D9E6DC] font-medium py-4 px-3 text-sm  max-sm:px-1.5 max-sm:text-[0.6rem] max-sm:py-2 ">
                <p>{val.course_name}</p>
                {val.coursePrice && <p> ₹ {val.coursePrice}</p>}
              </div>
            </div>
            <div>{array.length - 1 !== index && <FaPlus />}</div>
          </>
        ))}
      </div>
      <div className="flex justify-between items-center max-sm:text-sm font-semibold px-3">
        <p className="flex items-center font-semibold gap-2 my-5  max-sm:text-sm">
          2 Courses
          <PiFilesFill className="text-xl" />{" "}
        </p>
        {discountPrice && (
          <div className="flex gap-3 items-center">
            <p> ₹ {discountPrice} </p>
            <p className="line-through text-sm mt-[0.1rem]">
              {" "}
              ₹ {Number(coursePrice1) + Number(coursePrice2)}{" "}
            </p>
          </div>
        )}
      </div>

      <div className="mt-3" onClick={() => window.open(razorLink)}>
        <button className="bg-primary animate-pulse rounded-md text-white  font-normal  text-base  max-sm:text-xs py-[0.7rem] px-8 w-full">
          Enroll Now
        </button>
      </div>
    </div>
  );
};

export default Card;
